<mat-card style="border-color: #5775a8;">
  <mat-card-header cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="background-color: #5775a8;">
    <div class="flex flex-row rounded-lg w-full" style="align-items: center;">
      <div class="flex flex-col w-full" style="padding-right: 20px;">
        <h4 *ngIf="ids" style="color:white;"><b>Edit Existing Inspection</b></h4>
        <h4 *ngIf="!ids" style="color:white;"><b>Add New Inspection</b></h4>
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <form [formGroup]="form">

      <div class="flex flex-col w-full modal-body">

        <table>
          <tr *ngIf="canEdit">
            <td>
              <div *ngIf="edit">
                <mat-form-field class="container">
                  <mat-label>Visit Date</mat-label>
                  <input matInput [matDatepicker]="visitDate" formControlName="visitDate">
                  <mat-datepicker-toggle matSuffix [for]="visitDate"></mat-datepicker-toggle>
                  <mat-datepicker #visitDate></mat-datepicker>
                  <mat-error *ngIf="form.get('visitDate').invalid">
                    Invalid Date.
                  </mat-error>
                </mat-form-field>
              </div>
            </td>
            <td>
              <!-- Type -->
              <div *ngIf="inspectionType == 0">
                <mat-form-field class="container">
                  <mat-label>Visit Type:</mat-label>
                  <mat-select formControlName="inspectionType" (selectionChange)="setType($event.value)">
                    <mat-option value=''></mat-option>
                    <mat-option value='1'>Initial</mat-option>
                  </mat-select>
                  <mat-error *ngIf="form.get('inspectionType').invalid">
                    This field is required
                  </mat-error>
                </mat-form-field>
              </div>
              <div *ngIf="inspectionType > 0">
                <span *ngIf="inspectionType == 1">Initial</span>
                <span *ngIf="inspectionType == 2">Follow Up</span>
                <span *ngIf="inspectionType == 3">Post Remediation Plan</span>
              </div>
            </td>
          </tr>
          <tr>
            <td>
              <div class="flex clex-col w-full">
                <mat-form-field class="w-full">
                  <mat-label>Comments</mat-label>
                  <textarea matInput cdkTextareaAutosize formControlName="comments" cdkAutosizeMinRows="6"></textarea>
                </mat-form-field>
              </div>
            </td>
            <td>
              <!-- Conducted -->
              <div *ngIf="inspectionType > 0" class="flex flex-col">
                <span>Was the site visit conducted</span>
                <div class="flex flex-col w-full" style="align-items: baseline;">
                  <mat-radio-group formControlName="followupConducted">
                    <mat-radio-button color="primary" class="p-x-8" value='1'
                      (change)="siteVisit('1')">Yes</mat-radio-button>
                    <mat-radio-button color="primary" class="p-l-8" value='0'
                      (change)="siteVisit('0')">No</mat-radio-button>
                  </mat-radio-group>
                </div>
                <br />
                <div *ngIf="followup == 0 " class="flex flex-col w-full">
                  <span>Reason why Site Visit was not conducted?</span>
                  <div class="flex flex-col w-full" *ngIf="inspectionType == 1">
                    <mat-radio-group formControlName="visitConductedReason">
                      <mat-radio-button color="primary" value="1">Site Visit Denied (Forwarded to
                        OHA)</mat-radio-button>
                      <mat-radio-button color="primary" value="2">Failure to develop Remediation Plan (Forwarded to
                        OHA)</mat-radio-button>
                      <mat-radio-button color="primary" value="3">Other - Explain in Comment</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <span *ngIf="inspectionType >= 2" style="color:red;">Explain in Comments why the site visit was not
                    conducted</span>

                </div>
                <div *ngIf="followup == 1" class="flex flex-col w-full">
                  <span>Violation Found ?</span>
                  <div class="flex flex-col w-full" style="align-items: baseline;" *ngIf="inspectionType == 1">
                    <mat-radio-group formControlName="remediationResult">
                      <mat-radio-button color="primary" class="p-x-8" value="1">No</mat-radio-button>
                      <mat-radio-button color="primary" class="p-l-8" value="2">Yes - Violation Found</mat-radio-button>
                    </mat-radio-group>
                  </div>
                  <div class="flex flex-col w-full" style="align-items: baseline;" *ngIf="inspectionType == 2">
                    <mat-radio-group formControlName="remediationResult">
                      <mat-radio-button color="primary" (click)="postRemediation(1)" value="1">The business completed
                        the remediation plan successfully (complaint resolved).</mat-radio-button>
                      <mat-radio-button color="primary" (click)="postRemediation(2)" value="2">The business did NOT
                        complete the remediation plan (forward this complaint to OHA).</mat-radio-button>
                      <mat-radio-button color="primary" (click)="postRemediation(3)" value="3">The business completed
                        the remediation, and another violation was observed (forward this complaint to
                        OHA).</mat-radio-button>
                      <mat-radio-button color="primary" (click)="postRemediation(4)" value="4">The business did NOT
                        complete the remediation plan, and additional violations were observed (forward this complaint
                        to OHA).</mat-radio-button>
                    </mat-radio-group>
                    <span *ngIf="postRem != null && postRem > 1" class="text-danger">
                      <br /><br />
                      <span class="glyphicon glyphicon-warning-sign"></span> You have chosen a Visit Result that
                      requires you to forward this Complaint to OHA
                    </span>
                  </div>
                  <div class="flex flex-col w-full" style="align-items: baseline;" *ngIf="inspectionType == 3">
                    <mat-radio-group formControlName="remediationResult">
                      <mat-radio-button color="primary" (click)="postRemediation(1)" value="1">No
                        Violations</mat-radio-button>
                      <mat-radio-button color="primary" (click)="postRemediation(2)" value="2">Violations observed
                        (forward this complaint to OHA).</mat-radio-button>
                    </mat-radio-group>
                    <span *ngIf="postRem != null && postRem > 1" class="text-danger">
                      <br /><br />
                      <span class="glyphicon glyphicon-warning-sign"></span> You have chosen a Visit Result that
                      requires you to forward this Complaint to OHA
                    </span>

                  </div>

                </div>
              </div>
            </td>
          </tr>
        </table>
        <div class="flex flex-row ">
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="save()" class="m-8 container" style="background: #7ABDF3;">
              Save
            </button>
          </div>
          <div style="padding-right: 20px;">
            <button mat-raised-button (click)="return()" class="m-8 container">
              Return
            </button>
          </div>
        </div>
      </div>
    </form>

  </mat-card-content>

</mat-card>